module.exports = __webpack_public_path__ + "media/images/offer-shop-6a95b95dd905950ad2dfe45b687c77a8.png";